export class IAnalysisType {
    name: string;
    type: AnalysisType;
}

export enum AnalysisType {
    Soil = 1,
    Nitrogen = 2,
    HSA = 3
}

export interface IGlobalAllocationsBindingModel {
    YearId: number;
    AnalysisType: AnalysisType;
    Analysis: IGlobalAnalysisBindingModel[];
}

export interface IGlobalAnalysisBindingModel {
    AnalysisId: number;
    Allocations: IGlobalAllocationBindingModel[];
}

export interface IGlobalAllocationBindingModel {
    AnalysisId: number;
    AllocationId?: number;
    FieldId: number;
    CroppingId?: number;
    ZoneId?: number;
    SoilTypeLayerId?: number;
    SoilAnalysisLayerId?: number;
}
